import ObjectFilterSelect from 'automation-ui-log-events/components/ObjectFilterSelect';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { connect } from 'react-redux';
import * as localStorageActions from 'automation-ui-canvas/actions/LocalStorageActions';
import { getPreviouslyTestedObjectId } from 'automation-ui-canvas/selectors/localStorageSelectors';
import { useEffect } from 'react';
import * as LocalStorageKeys from 'automation-ui-canvas/constants/LocalStorageKeys';
import PortalIdParser from 'PortalIdParser';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DebuggerPanelSourceSelectBody = ({
  flowObjectTypeId,
  onObjectIdSelected,
  objectId,
  previouslyTestedObject,
  mergeDeepWithLocalStorage
}) => {
  const handleObjectIdSelected = newObjectId => {
    const portalId = PortalIdParser.get();
    onObjectIdSelected(newObjectId);
    mergeDeepWithLocalStorage({
      [`${LocalStorageKeys.PREVIOUSLY_TESTED_OBJECT_ID}-${portalId}`]: {
        objectId: newObjectId,
        objectTypeId: flowObjectTypeId
      }
    });
  };
  useEffect(() => {
    if (previouslyTestedObject && flowObjectTypeId === previouslyTestedObject.objectTypeId) {
      onObjectIdSelected(previouslyTestedObject.objectId);
    }
  }, [previouslyTestedObject, onObjectIdSelected, flowObjectTypeId]);
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "stretch",
    justify: "between",
    backgroundColor: "fill-surface-raised",
    paddingInline: "400",
    paddingBlockStart: "400",
    paddingBlockEnd: "600",
    children: [/*#__PURE__*/_jsx(UIFormLabel, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "debuggerPanel.sourceSelect.inputTitle"
      })
    }), /*#__PURE__*/_jsx(ObjectFilterSelect, {
      flowObjectTypeId: flowObjectTypeId,
      updateUrlFilters: ({
        target: {
          value
        }
      }) => {
        handleObjectIdSelected(Number(value));
      },
      selectedObjectId: objectId,
      "data-test-id": "test-enroll-object-dropdown",
      extraSelectProps: {
        buttonUse: 'form-on-dark'
      }
    })]
  });
};
export default connect(state => ({
  previouslyTestedObject: getPreviouslyTestedObjectId(state)
}), {
  mergeDeepWithLocalStorage: localStorageActions.mergeDeepWithLocalStorage
})(DebuggerPanelSourceSelectBody);